export type WithClassName = { className?: string };

export type SortTypes = 'date_asc' | 'date_desc';
export type GroupBy = 'location' | 'year';

export enum Locales {
  FR = 'fr',
  EN = 'en',
}
export type Trad = Record<Locales, string>;

export enum ZONES {
  ASIA = 'Asia',
  EUROPE = 'Europe',
}

export enum COUNTRIES {
  DE = 'Germany',
  DK = 'Denmark',
  FR = 'France',
  HU = 'Hungary',
  IT = 'Italy',
  KH = 'Cambodia',
  MY = 'Malaysia',
  SG = 'Singapore',
  TH = 'Thailand',
}

export type PhotoLocation = {
  zone: ZONES;
  country: COUNTRIES;
  region?: string;
  city?: string;
  detail?: string;
};

export type Person = {
  name: string;
  link?: string;
};

export type Series = {
  id: string;
  name: string | Trad;
  description?: string;
  location?: PhotoLocation;
  sortType?: SortTypes;
  groupBy?: GroupBy;
  isZoneHighlight?: boolean;
};

export type Photo = {
  id: string;
  name?: string;
  date: string;
  location: PhotoLocation | string;
  people?: Person[];
  color?: boolean;
  coverPosition?: string;
  coverSize?: string;
  seriesIds?: string[];
  seriesCover?: string[] | boolean;
};
